import { render, staticRenderFns } from "./RecentWorks.vue?vue&type=template&id=1e45b726"
import script from "./RecentWorks.vue?vue&type=script&lang=js"
export * from "./RecentWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports